import { MultiLegShippingEmissionEstimate } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { Leg } from '@lune-fe/lune-components-lib'
import { FC } from 'react'

import MultiLegEstimate from 'views/CalculateEmissions/MultiLegLogistics/MultiLegEstimate'

interface MultiLegShippingEstimateDetailsProps {
    estimate: SuccessResponseWithMeta<MultiLegShippingEmissionEstimate>
    legs: Leg[]
}

export const MultiLegShippingEstimateDetails: FC<MultiLegShippingEstimateDetailsProps> = ({
    estimate,
    legs,
}) => {
    return (
        <MultiLegEstimate
            legs={legs}
            load={estimate.request.shipment}
            meta={estimate._meta}
            source={'source' in estimate ? estimate.source : undefined}
        />
    )
}
